// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__1RGnM","content":"Projects_content__XpP6A","desc_2":"Projects_desc_2__zLuHA"};